import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";

export class ManageSeatingContext {
    public routeTo: string[] = [];
    public actionResult: Partial<IDefaultActionResult> = {}

    constructor() {

    }
}